import { useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import type { Me } from '@/api/types';
import { useAuth } from '@/auth';

export const SESSION_QUERY_KEY = ['me'] as const;

/**
 * The server's view of the signed-in person in THIS space: roles, permissions
 * and contracted modules/features. Everything the UI shows or hides derives
 * from it, but the API re-checks every request: hiding is UX, not security.
 */
export function useSession() {
  const { status } = useAuth();
  return useQuery({
    queryKey: SESSION_QUERY_KEY,
    queryFn: ({ signal }) => api.get<Me>('/me', { signal }),
    enabled: status === 'authenticated',
    staleTime: 60_000,
    retry: false,
  });
}

/** Like useSession, but for components rendered under <SessionGate> (data is loaded). */
export function useMe(): Me {
  const { data } = useSession();
  if (!data) throw new Error('useMe must be used inside <SessionGate>.');
  return data;
}
